export default __webpack_public_path__ + "static/media/LPT.010c9db2.svg";